export const _setSelectedSsaStudent = (state, action) => {
  state.selectedSsaStudent = action.payload;
};

export const _setSelectedStudentsList = (state, action) => {
  state.selectedStudentsList = action.payload;
};

export const _setSelectedMultipleStudents = (state, action) => {
  state.selectedMultipleStudents = action.payload;
};

export const _setSelectedSsaStudentDetails = (state, action) => {
  state.selectedSsaStudentDetails = action.payload;
};

export const _setSelectedStudentHeadingDetails = (state, action) => {
  state.selectedStudentHeadingDetails = action.payload;
};

export const _setNonCompliantOnly = (state, action) => {
  state.nonCompliantOnly = action.payload;
};
